import { render, staticRenderFns } from "./TgjuPostComments.vue?vue&type=template&id=7e1f9e7a&"
import script from "./TgjuPostComments.vue?vue&type=script&lang=js&"
export * from "./TgjuPostComments.vue?vue&type=script&lang=js&"
import style0 from "./TgjuPostComments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports